import React, { useState } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { RiAccountPinCircleFill } from "react-icons/ri";
import "./Header.css"; // Import external CSS

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="header-container">
            {/* Logo Section */}
            <section className="logo-container">
                <img src='/assets/images/logo.webp' alt='Logo' />
                <p>Sri Amman Sweets</p>
            </section>

            {/* Mobile Menu Toggle Button */}
            <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                &#9776;
            </div>

            {/* Navigation Links */}
            <nav className={`nav-bar-container ${isMenuOpen ? 'show-menu' : ''}`}>
                <Link to="/" className='nav-link'>Home</Link>
                <Link to="/about" className='nav-link'>About</Link>
                {/* <Link to="/savouries" className='nav-link'>Savouries</Link> */}
                <Link to="/contact" className='nav-link'>Contact</Link>
            </nav>

            {/* Account Icon */}
            <Link to="/account" className='account-icon'>
                <RiAccountPinCircleFill size={30} />
            </Link>
        </header>
    );
}

export default Header;
